/** Comp Topic Detail Fatigue KPI selector (no Adge Score). */
export const COMP_TOPIC_DETAIL_FATIGUE_KPIS = [
  "Days",
  "Assets",
  "Days/Assets",
  "Asset %",
] as const;

export type CompTopicDetailFatigueKpi = (typeof COMP_TOPIC_DETAIL_FATIGUE_KPIS)[number];
